export const HUMALONG_SONGS = [
  { id: 'oldmacdonald' },
  { id: 'twinkletwinkle' },
  { id: 'rowrowboat' },
];
export const HUMALONG_VO = {
  select_song: ['NFC_3.0_54'],
  start_interaction: ['NFC_3.0_56'],
  complete: ['NFC_6.0_98'],
  twinkletwinkle: 'NFC_7.0_125',
  oldmacdonald: 'NFC_7.0_127',
  rowrowboat: 'NFC_7.0_126',
  hum_twinkletwinkle: 'NFC_7.0_128',
  hum_oldmacdonald: 'NFC_7.0_130',
  hum_rowrowboat: 'NFC_7.0_129',
};
